export default "__VITE_ASSET__CzKNaLzt__"